import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import DatePicker from "react-datepicker";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  openSalesReportExportModal,
  fetchDownloadSalesReport,
} from "TicketAction";
import { COMMON_FAIL_MESSAGE, DISPLAY_DATE_FORMAT } from "Constants";
import LocaleStrings from "Languages";
import Loader from "Loader";

class ExportData extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, startDate: "", endDate: "" };

    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({ loading: false });
    this.props.openSalesReportExportModal({ show: true });
  }

  closeModal() {
    this.props.openSalesReportExportModal({ show: false });
    this.setState({ startDate: "", endDate: "" });
  }

  downloadCSV = () => {
    let { session } = this.props;
    let { startDate, endDate } = this.state;

    this.setState({ loading: true });
    this.props.fetchDownloadSalesReport(
      session,
      startDate,
      endDate,
      (response) => {
        this.setState({ loading: false });
        if (response.success) {
          this.props.JSONToCSVConvertor(response.data.result);
          this.closeModal();
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  _handleStartDate = (date) => {
    // let formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss");
    this.setState({ startDate: date });
  };

  _handleEndDate = (date) => {
    // let formattedDate = moment(date).format("YYYY-MM-DD HH:mm:ss");
    this.setState({ endDate: date });
  };

  render() {
    let { loading } = this.state;
    let { showModal } = this.props;

    return (
      <div>
        <span className="">
          <Button
            type="button"
            className="btn-custom-white"
            onClick={this.openModal}
            disabled={loading}
          >
            {LocaleStrings.button_csv_export}
          </Button>
        </span>
        <div>
          <Modal
            className="modal-container"
            show={showModal.show === true ? true : false}
            onHide={this.closeModal}
            animation={true}
            dialogClassName="size600PxModal"
          >
            <Modal.Header>
              <div className="import-modal-title">
                {LocaleStrings.tickets_salesreport_export_text_export_record}
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.closeModal()}
              >
                <img
                  className="i-custom-small"
                  src="../../style/images/custom-icons/cross-black.png"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              <div
                className="vertical-align-center text-center"
                style={{ minHeight: 250 }}
              >
                {loading ? (
                  <div className="loader-container">
                    <Loader />
                    <div className="loader-info">
                      {
                        LocaleStrings.tickets_salesreport_export_text_export_sales_csv_downloading
                      }
                    </div>
                  </div>
                ) : (
                  <div>
                    <p className="custom-text1-primary-normal">
                      {
                        LocaleStrings.tickets_salesreport_export_text_export_sales_csv
                      }
                    </p>

                    <div style={{ marginTop: 10 }}>
                      <DatePicker
                        placeholderText={LocaleStrings.startdate}
                        selected={this.state.startDate}
                        onChange={(date) => this._handleStartDate(date)}
                        selectsStart
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        dateFormat={DISPLAY_DATE_FORMAT}
                      />
                    </div>
                    <div style={{ marginTop: 10 }}>
                      <DatePicker
                        placeholderText={LocaleStrings.enddate}
                        selected={this.state.endDate}
                        onChange={(date) => this._handleEndDate(date)}
                        selectsEnd
                        startDate={this.state.startDate}
                        endDate={this.state.endDate}
                        minDate={this.state.startDate}
                        dateFormat={DISPLAY_DATE_FORMAT}
                      />
                    </div>
                  </div>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="btn btn-custom-blue"
                onClick={this.downloadCSV}
                loading={loading}
                disabled={loading}
                type="button"
              >
                {LocaleStrings.button_download}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.ShowSalesReportExportModal,
  };
}

export default connect(mapStateToProps, {
  openSalesReportExportModal,
  fetchDownloadSalesReport,
  showError,
  showSuccess,
})(ExportData);
